<template>
<div>
  <section id="contents" class="page_register">
  	<div id="title_block">
  		<h1 class="title_text">メール確認</h1>
  		<p class="btn_back"><a href="javascript:history.back();">戻る</a></p>
  	</div>
    <div class="contents_inner">
      <ul class="flow_box step_num3">
        <li class="current">情報入力</li>
        <li class="current">メール確認</li>
        <li>完了</li>
      </ul>
      <form @submit.prevent="mail_confirm">
        <div class="form_box">
          <table>
            <tr>
              <th>メールアドレス<span>必須</span></th>
              <td><p><input type="text" placeholder="" v-model="username" required></p></td>
            </tr>
            <tr>
              <th>確認コード<span>必須</span></th>
              <td><p><input type="text" placeholder="" v-model="confirmationCode" required></p></td>
            </tr>
          </table>
        </div>
	  		<p class="submit"><input type="submit" value="この内容で登録"></p>
      </form>
    </div>
  </section>
</div>
</template>

<script>
import Vue from 'vue'
import IdHeader from './Header'
Vue.component('id-header', IdHeader)

export default {
  name: 'Confirm',
  data () {
    return {
      appId: this.$route.query.app_id, 
      username: '',
      confirmationCode: ''
    }
  },
  methods: {
    mail_confirm () {
      this.$cognito.confirmation(this.username, this.confirmationCode)
        .then(result => {
          this.$router.replace('/login?app_id='+this.appId)
        })
        .catch(err => {
          this.$notify({ group: 'main', type: 'error', text: this.$i18n.t("message.confirm." + err.code) })
        })
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/user.css'
</style>



// WEBPACK FOOTER //
// src/components/Confirm.vue